import React from "react";
import ModalComponent from "./Modal";
import { Typography, Button, Box } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const CloseApplicationModal = ({ showCloseModal, onClose, minutesLeft }) => {
  return (
    <ModalComponent open={showCloseModal} handleClose={onClose} width="450px">
      <Box sx={{ textAlign: "center", p: 1 }}>
        <WarningAmberRoundedIcon color="error" sx={{ fontSize: 50, mb: 2 }} />
        <Typography variant="h6" gutterBottom fontWeight="bold">
          ¡Importante!
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          La aplicación se cerrará automáticamente en {""}
          <Box component="span" fontWeight="bold">
            aproximadamente {minutesLeft ?? "unos pocos"} minutos.
          </Box>
        </Typography>
        <Button variant="contained" onClick={onClose} fullWidth sx={{ mt: 2 }}>
          Entendido
        </Button>
      </Box>
    </ModalComponent>
  );
};

export default CloseApplicationModal;
